const header = document.getElementById("header");

if (header?.dataset.isTransparent === "true") {
	const threshold = document.getElementById("top-banner")?.offsetHeight || 50;
	const sentinel = document.createElement("div");
	Object.assign(sentinel.style, {
		position: "absolute",
		top: `${threshold}px`,
		width: "1px",
		height: "1px",
		pointerEvents: "none",
		visibility: "hidden",
	});
	document.body.appendChild(sentinel);

	const observer = new IntersectionObserver(([entry]) => {
		// When sentinel is not intersecting viewport, we've scrolled past threshold
		header.dataset.headerScrolled = (!entry.isIntersecting).toString();
	});

	observer.observe(sentinel);

	/* Hot-module-reload cleanup (dev only) */
	import.meta.hot?.dispose(() => {
		observer.disconnect();
	});
}
